import { render } from "./CadastrarEspecialidade.vue?vue&type=template&id=cc79e23c&scoped=true"
import script from "./CadastrarEspecialidade.vue?vue&type=script&lang=js"
export * from "./CadastrarEspecialidade.vue?vue&type=script&lang=js"

import "./CadastrarEspecialidade.vue?vue&type=style&index=0&id=cc79e23c&scoped=true&lang=css"

import exportComponent from "I:\\Centrion\\projetos\\aut_fri_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc79e23c"]])

export default __exports__